import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { darkColors, Modal, theme } from '@tryhackme/thm-ui-components';
import { Link } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { useGetUserQuery } from 'src/common/slices';
import { Countdown } from 'src/features/campaigns/components/countdown';
import { useCampaignStorage } from 'src/features/campaigns/hooks/use-campaign-storage';
import { useActiveCampaign } from 'src/features/campaigns/hooks/use-active-campaign';
import { useInfluencerCampaign } from '../../hooks/use-influencer-campaign';
import { useInfluencerAdditionalConfigs } from '../../hooks/use-influencer-additional-configs';
import { StyledContent, StyledCountdownWrapper, StyledMainText, StyledRedirectButton, StyledWrapper, Styledtag } from './influencer-campaign-modal.styles';
export const InfluencerCampaignModal: FC = () => {
  const {
    data: userDataResponse
  } = useGetUserQuery();
  const {
    campaign
  } = useActiveCampaign();
  const {
    isSeen,
    markAsSeen
  } = useCampaignStorage(campaign);
  const {
    userFriendlyName,
    isExtended,
    shouldIncludeDays,
    percentageOff,
    calculatedEndTime
  } = useInfluencerCampaign(campaign?.name);
  const isLoggedIn = !!userDataResponse?.data;
  const [open, setOpen] = useState(isLoggedIn && !isSeen);
  useEffect(() => {
    setOpen(isLoggedIn && !isSeen);
  }, [isLoggedIn, isSeen]);
  const onOpenChange = (isOpen: boolean) => {
    if (isOpen) return;
    markAsSeen();
    setOpen(false);
  };
  const handleCtaClick = () => {
    markAsSeen();
    setOpen(false);
  };
  const additionalConfigs = useInfluencerAdditionalConfigs(campaign?.name);
  if (!additionalConfigs) {
    return null;
  }
  const {
    urlToNavigate,
    detailsRedirect,
    InfluencerIcon
  } = additionalConfigs;
  if (!campaign) return null;
  const url = userDataResponse?.data ? detailsRedirect : urlToNavigate;
  const startTime = campaign?.startTime ?? 0;
  return <ThemeProvider theme={{
    ...theme,
    colors: darkColors
  }} data-sentry-element="ThemeProvider" data-sentry-component="InfluencerCampaignModal" data-sentry-source-file="influencer-campaign-modal.tsx">
      <Modal open={open} onOpenChange={onOpenChange} padding="0" overflowVisible={false} data-sentry-element="Modal" data-sentry-source-file="influencer-campaign-modal.tsx">
        <StyledWrapper data-sentry-element="StyledWrapper" data-sentry-source-file="influencer-campaign-modal.tsx">
          <StyledContent data-sentry-element="StyledContent" data-sentry-source-file="influencer-campaign-modal.tsx">
            <InfluencerIcon width="300" height="237" data-sentry-element="InfluencerIcon" data-sentry-source-file="influencer-campaign-modal.tsx" />
            <Styledtag data-sentry-element="Styledtag" data-sentry-source-file="influencer-campaign-modal.tsx">{userFriendlyName} viewers exclusive</Styledtag>
            {isExtended ? <div>
                <StyledMainText>
                  FINAL CHANCE TO <span>SAVE {percentageOff}%!</span>
                </StyledMainText>
                <p>
                  Extended on popular demand, the <strong>{percentageOff}%</strong> off Jr Penetration Tester
                  Certification is still live - but not for long.
                </p>
              </div> : <div>
                <StyledMainText>
                  <span>{percentageOff}% off</span> Jr Penetration Tester certification!!
                </StyledMainText>
                <p>
                  You&apos;ve unlocked a special offer! {userFriendlyName} viewers get{' '}
                  <strong>{percentageOff}% off</strong> Jr Penetration Tester Certification!
                </p>
              </div>}
            {!isExtended && <StyledCountdownWrapper>
                <p>Offer ends in: </p>
                <Countdown includeDays={shouldIncludeDays} dark vertical startTime={startTime} endTime={calculatedEndTime} />
              </StyledCountdownWrapper>}
            <StyledRedirectButton as={Link} to={url} onClick={handleCtaClick} variant="solid" color="primary" data-sentry-element="StyledRedirectButton" data-sentry-source-file="influencer-campaign-modal.tsx">
              Let&apos;s Go!
            </StyledRedirectButton>
          </StyledContent>
        </StyledWrapper>
      </Modal>
    </ThemeProvider>;
};